/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { handleBlobResponse } from '../../../../client/js/lib/download'
import rest from '../../../../client/js/lib/rest'

export function deleteEstateTemplateById (id: string) {
  return rest.delete(`/api/estates/templates/${id}/file`)
}

export function downloadEstateTemplateById (id: string) {
  return rest.get(`/api/estates/templates/${id}/file`)
    .then(handleBlobResponse)
}

export function fetchEstateTemplateById (id: string): Promise<S3TemplateMeta> {
  return rest.get(`/api/estates/templates/${id}`)
    .then((resp) => resp.json())
}

export function uploadEstateTemplate (id: string, file: File) {
  const fd = new FormData()
  fd.append('file', file)
  return rest.put(`/api/estates/templates/${id}/file`, { body: fd })
    .then((resp) => resp.json())
}
